import React from "react"
import ReactSVG from "react-svg"
import InstacartLogo from "../../../../images/dashboard/instacart-short.svg"
import caShortLogo from "../../../../images/ca-orange-short.svg"
import { INSTACART, INSTACART_CANADA } from "../../../../v1/constants/affiliations"

const DiscountRibbon = ({ title, user, children }) => {
  let discountLogo = caShortLogo
  if ([INSTACART, INSTACART_CANADA].includes(user?.affiliation?.root_reference_id)) {
    discountLogo = InstacartLogo
  }

  return (
    <div className="discount-ribbon">
      <ReactSVG src={discountLogo} />
      {title && <p className="ribbon-text">{title}</p>}
      {children}
    </div>
  )
}

export default DiscountRibbon
